import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify'
import AboutUsView from './pages/AboutUsView'
import CareersView from './pages/CareersView'
import ContactUsView from './pages/ContactUsView'
import IndexView from './pages/IndexView'
import LeadershipView from './pages/LeadershipView'

Vue.config.productionTip = false
Vue.use(VueRouter);

const routes = [
    { path: '/about-us', component: AboutUsView},
    { path: '/careers', component: CareersView },
    { path: '/contact-us', component: ContactUsView },
    { path: '/leadership', component: LeadershipView },
    { path: '/', component: IndexView }
];

/**
 * History mode is the preferred method for SEO benefits
 * however, it requires Apache configuration that was not
 * playing nicely.  To avoid Apache configuration and 
 * messing with getting the history mode to work on prod
 * I'm opting to use the default hashing mode.
 * 
 * If there is ever a push to massively overhaul the website
 * it would make sense at that point to just rewrite it
 * in React anyway as Vue 2 is EoL.
 */

const router = new VueRouter({
    // mode: 'history',
    routes,
    scrollBehavior() {
        // Always scroll to top
        window.scrollTo({top: 0, left: 0});
    },
});

new Vue({
    router,
    render: function(createElement){
        return createElement(App)
    },
    vuetify
}).$mount('#app')
